module.exports = require("quill");